import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=7bc3ff2f&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=7bc3ff2f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc3ff2f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bc3ff2f')) {
      api.createRecord('7bc3ff2f', component.options)
    } else {
      api.reload('7bc3ff2f', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=7bc3ff2f&scoped=true&", function () {
      api.rerender('7bc3ff2f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24EhCBt4M16o6/JS/comp/PopupBox.vue"
export default component.exports